import { render, staticRenderFns } from "./integrations-that-support.vue?vue&type=template&id=140ae798&scoped=true&"
import script from "./integrations-that-support.vue?vue&type=script&lang=js&"
export * from "./integrations-that-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ae798",
  null
  
)

export default component.exports